import { render, staticRenderFns } from "./IhaIssueDetail.vue?vue&type=template&id=7df8ae84&scoped=true&"
import script from "./IhaIssueDetail.vue?vue&type=script&lang=js&"
export * from "./IhaIssueDetail.vue?vue&type=script&lang=js&"
import style0 from "./IhaIssueDetail.vue?vue&type=style&index=0&id=7df8ae84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df8ae84",
  null
  
)

export default component.exports